/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneCheckoutFooter as ResolvedStandaloneCheckoutFooter } from 'base/components/standalone/CheckoutFooter';

export const CheckoutFooter: typeof ResolvedStandaloneCheckoutFooter = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneCheckoutFooter {...props} />
        </ErrorBoundary>
    );
});

export type CheckoutFooterProps = PropsFromComponent<typeof CheckoutFooter>;

/** @deprecated Use slot architecture instead */
export const CheckoutFooterWith = (extras: DynamicStandaloneExtras): typeof CheckoutFooter => {
    return function CheckoutFooter(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CheckoutFooter');
        return <ResolvedStandaloneCheckoutFooter {...mergeProps({ options: { theme } }, props)} />;
    }
}